// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\FractionsPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function FractionsPage() {
  return <TutorPage initialTopic="Fractions" lockTopic />;
}